module.exports = __webpack_public_path__ + "assets/images/grid/green-xmas-8.jpg?v=21943a11";